import { Link } from "react-router-dom";
import { NonIdealState } from "@blueprintjs/core";
import { Button } from "@mantine/core";

import { useBasePath } from "@hooks";

export const TeamsTierUpsell: React.FC = () => {
  const basePath = useBasePath();

  return (
    <div data-testid="teams-tier-upsell">
      <NonIdealState
        title="✨ Team Tier Feature ✨"
        description="It looks like your organization does not have the teams tier enabled."
        action={
          <Button
            component={Link}
            to={`${basePath}/settings/upgrade`}
            color="violet"
          >
            Upgrade
          </Button>
        }
      />
    </div>
  );
};
